import { useEffect } from 'react';

import { runTour } from './tour.runner';

export const TourRouteSync = ({
  currentTourRef,
}: {
  currentTourRef: React.MutableRefObject<Awaited<
    ReturnType<typeof runTour>
  > | null>;
}) => {
  useEffect(() => {
    const handler = () => {
      currentTourRef.current?.destroy?.();
      currentTourRef.current = null;
    };

    window.addEventListener('popstate', handler);

    return () => {
      window.removeEventListener('popstate', handler);
    };
  }, [currentTourRef]);

  return null;
};
